import { jsx as r } from "react/jsx-runtime";
import { IconClose as n } from "../Icon/24/IconClose.js";
import "clsx";
import { ArrowLeftIcon as e } from "../../icons/ArrowLeftIcon.js";
import { ArrowRightIcon as c } from "../../icons/ArrowRightIcon.js";
import { CheckmarkIcon as i } from "../../icons/CheckmarkIcon.js";
import { PlusIcon as m } from "../../icons/PlusIcon.js";
const t = {
  arrowLeft: /* @__PURE__ */ r(e, {}),
  arrowRight: /* @__PURE__ */ r(c, {}),
  check: /* @__PURE__ */ r(i, {}),
  close: /* @__PURE__ */ r(n, {}),
  plus: /* @__PURE__ */ r(m, {})
}, s = (o) => typeof o == "string" && o in t;
function h(o) {
  return s(o) ? t[o] : null;
}
const w = {
  gridGutter: {
    space: {
      xxs: 16,
      l: 36
    }
  }
};
export {
  h as getButtonIcon,
  t as iconSet,
  s as isButtonIcon,
  w as presets
};
